export default __webpack_public_path__ + "static/media/cancer10.31bf2991.jpg";